import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTableProperty extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelAuditLogExcludeHeading: Label;
    labelAuditing: Label;
    panelAuditLogExclude: Panel;
    panelAuditing: Panel;
    panelHeader: Panel;
    panelShared: Panel;
    sourceAuditLogExclude: DataSource;
    sourceTableProperty: DataSource;
    switchAudited: Switch;
    switchBroadcasted: Switch;
    switchDeletes: Switch;
    switchInserts: Switch;
    switchNonIndexedqueryrestricted: Switch;
    switchShared: Switch;
    switchUpdates: Switch;
    tableAuditLogExclude: Table;
    textboxDaysToKeep: Textbox;
    textboxTableName: Textbox;
}
